export const LOGIN_STATES = {
    LOGIN: 0,
    SIGNUP: 1,
    FORGOT: 2,
}